var DocumentNumberSettingModule = (function () {
    function DocumentNumberSettingModule() {
    }
    return DocumentNumberSettingModule;
}());
export { DocumentNumberSettingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting.module.ts.pre-build-optimizer.js